export default {
  language: "중국어 간체",
  // 항해
  zdy: {
    tjsq: "신청서 제출",
    czsl: "재충전 수량",
    enterczsl: "충전 금액을 입력하십시오",
    qbdz: "지갑 주소",
    enterqbdz: "지갑 주소를 입력하십시오",
    sftjmcj: "주문 판매 가격 제출 여부",
    sftjmrj: "주문 구매 가격 제출 여부",
    proloss: "이익 중지 손실 중지",
  },
  header: {
    home: "홈",
    markets: "따옴표",
    fiat: "법정 화폐 거래",
    c2c: "C2C 거래",
    exchange: "코인 거래",
    lever: "계약 거래",
    micro: "두 번째 계약 거래",
    myshop: "내 가게",
    assets: "내 자산",
    help: "도움말 센터",
    login: "로그인",
    sign: "등록",
    accountSet: "계정 설정",
    tradeLog: "거래 로그",
    receiveSet: "영수증 설정",
    identify: "신원 인증",
    jchange: "코인 교환",
    logout: "로그 아웃",
    themedark: "야간 모드",
    themeday: "주간 모드",
  },
  // 로그인 등록
  lg: {
    login: "로그인",
    register: "등록",
  },
  // 집
  home: {
    vol: "24H 볼륨",
    c01: "세계 최고의 디지털 자산 거래 플랫폼",
    c02: "전 세계 130 개 이상의 국가에서 수백만 명의 사용자에게 안전하고 신뢰할 수있는 디지털 자산 거래 및 자산 관리 서비스 제공",
    c03: "안전하고 신뢰할 수 있음",
    c04: "디지털 자산 금융 서비스 분야 5 년 경력",
    c05: "전문 분산 아키텍처 및 안티 DDOS 공격 시스템",
    c06: "글로벌 생태 레이아웃",
    c07: "여러 국가에서 현지화 된 거래 서비스 센터를 설립했습니다",
    c08: "다양한 비즈니스 형태로 블록 체인 생태계 구축",
    c09: "사용자 우선",
    c10: "선불 결제 메커니즘 설정",
    c11: "투자자 보호 기금 설립",
    c12: "언제 어디서나 멀티 플랫폼 단말 거래",
    c13: "iOS, 기계적 인조 인간, 윈도우 다중 플랫폼 커버, 완전한 비즈니스 기능 지원",
    sweep: "다운로드 할 코드 스캔",
    android: "기계적 인조 인간",
    pinput: "이메일 또는 전화 번호를 입력하세요",
    atrade:
      "거래를 시작하려면 Besencexchange 계정을 등록하십시오",
  },
  // 하단
  foo: {
    about: "회사 소개",
    support: "사용자 지원",
    contact: "문의하기",
    qq: "고객 서비스 QQ",
    email: "연락처 이메일",
    usdt: "시장",
    footlefta: "법적 고지",
    footleftb: "개인 정보 정책",
    footleftc: "사용자 계약",
    footmidd: "자금세탁방지 정보",
    footmide: "무기한 계약 거래 규칙",
    footrightf: "다운로드",
    footrightg: "안드로이드 다운로드",
  },
  // 인용문
  market: {
    handicap: "핸디캡",
    exchange: "동전 화폐",
    selfmarket: "선택",
    allmarket: "모든 시장",
    symbol: "거래 쌍",
    newprice: "최근 가격",
    change: "증가",
    highprice: "최고 가격",
    lowprice: "최저 가격",
    vol: "24H 볼륨",
  },
  // 공개 거래
  td: {
    buy: "구매",
    sell: "매도",
    currency: "통화",
    num: "숫자",
    time: "시간",
    limit: "한도",
    price: "단가",
    method: "결제 방법",
    total: "합계",
    inwant: "욕망을 입력하세요",
    do: "작업",
    more: "더로드하기",
    nomore: "더 이상은 없어",
    nodata: "일시적으로 데이터 없음",
    trade: "무역",
    buynum: "구매 수량",
    sellout: "판매",
    buyin: "구매",
    all: "모두",
    allbuy: "모두 구매",
    allsell: "모두 판매",
    buytotal: "구매하고자하는 총 금액을 입력하세요",
    selltotal: "판매하려는 총 금액을 입력하세요",
    buyallnum: "구매하려는 수량을 입력하세요",
    sellallnum: "판매 할 수량을 입력하십시오",
    tradeTotal: "총 거래 금액",
    doceil: "초 후 자동 취소",
    place: "주문하기",
    waitpay: "결제 보류",
    paycode: "결제 코드",
    finished: "완료 됨",
    ceiled: "취소됨",
    paid: "유료",
    nofinish: "미완성",
    buyer: "구매자",
    seller: "판매자",
    callWay: "연락처 정보",
    placeTime: "주문 시간",
    renum: "참조 번호",
    canceil: "취소",
    confirm: "확인",
    pwd: "거래 비밀번호를 입력하세요",
    coincode: "통화 단위",
    pcoin: "통화 단위를 선택하세요",
  },
  // 법정 화폐 거래
  fat: {
    // LegalPayDetail
    orderLog: "주문 기록",
    fatdLog: "피아트 통화 거래 기록",
    shoper: "판매자",
    faLog: "명령 통화 거래 기록",
    tdType: "거래 유형",
    odStatus: "주문 상태",
    pwaitPay: "구매자가 지불 할 때까지 기다려주세요",
    odFinish: "주문이 완료되었습니다",
    odCeil: "주문이 취소되었습니다",
    odPay: "지불, 지불 정보를주의 깊게 확인하십시오",
    tdCeil: "거래 취소",
    pCeil: "이미 판매자에게 결제했다면 거래를 취소하지 마세요",
    paySure: "결제 확인",
    pdopay: "판매자에게 지불했는지 확인하십시오",
    badClick: "악의적 인 클릭은 계정을 직접 정지시킵니다",
    receivePay: "영수증 확인",
    payReceive: "구매자가 당신에게 지불했는지 확인하십시오",
    receivePays: "결제가 수신되었는지 확인",
    // LegalPay
    payPlease: "제발 지불",
    tdPrice: "거래 단가",
    tdNum: "트랜잭션 수",
    payinfo: "결제 정보",
    banknum: "은행 계좌",
    realName: "실명",
    shoperZname: "판매자 지점",
    shoperNum: "판매자 계정",
    odCeil: "주문 취소",
    imPay: "지불했습니다. 확인하려면 클릭하세요.",
    // LegalSeller
    register_time: "등록 시간",
    odtotal: "조립 주문",
    odmonth: "주문이되기까지 30 일",
    odfinish: "주문 완료",
    odrate: "완료율",
    submit: "게시",
    phone: "모바일",
    mysell: "내 판매",
    mybuy: "내 구매",
    realAuth: "실명 인증",
    advAuth: "고급 인증",
    linebuy: "온라인 구매",
    linesell: "온라인 판매",
    tipPay:
      "결제를 위해 24 시간 이내에 가맹점에 연락하시면 24 시간 후 자동 취소됩니다",
    notlow: "최소 한도보다 낮을 수 없습니다",
    nothigh: "최대 한도를 초과 할 수 없음",
    notnum: "최대 수를 초과 할 수 없습니다",
    // LegalShopDetail
    type: "유형",
    status: "상태",
    seeOrder: "주문보기",
    withdraw: "철회",
    abnormal: "비정상",
    lowershelf: "기성품",
    protection: "권리 방어",
    apply: "권리 보호 신청",
    psType: "유형을 선택하십시오",
    pselect: "선택하십시오",
    alipay: "Alipay",
    wechat: "WeChat",
    bank: "은행 카드",
    minNum: "최소 거래량",
    maxNum: "최대 거래량",
    wantBuy: "구매",
    pnums: "번호를 입력하세요",
    pmin: "최소 거래량을 입력하세요",
    pmax: "최대 거래량을 입력하세요",
    pnot: "최대 거래량은 최소 거래량보다 적을 수 없습니다.",
    // MyLegalShops
    myshops: "내 가게",
    name: "이름",
    fiatSub: "화폐 통화에 속함",
    shoper_balance: "판매자 잔액",
    enterShop: "가게에 들어가기",
    // shop_legal_pay_detail
    payedWait: "지불, 확인 후 확인 대기",
    yes: "예",
    no: "아니",
    sd: "잔액 잠금",
    journal: "밸런스 저널",
    business: "비즈니스",
    user: "사용자",
    backdone: "철회",
    busbalance: "비즈니스 균형",
    userbalance: "사용자 잔액",
  },
  ctc: {
    ctc: "C2C",
    myRelease: "C2C 출시",
    myTrade: "C2C 내가 거래했습니다",
    and: "예",
    balance: "밸런스",
    buynum: "매수량",
    sellnum: "판매량",
    bankTransfer: "은행 송금",
    payim: "직접 지불해야합니다",
    pbuyNum: "구매 수량을 입력하세요",
    pprice: "단가를 입력하세요",
    payway: "결제 방법을 선택하세요",
    psellNum: "판매 수량을 입력하십시오",
    suerePlace: "주문을 하시겠습니까?",
    detail: "상세",
    payinfo: "결제 정보",
    Payee: "수취인",
    total: "합계",
    name: "이름",
    cardnum: "카드 번호",
    receivePay: "결제가 완료되었는지 확인",
    ceilConfirm: "거래 취소를 확인 하시겠습니까? ",
    paySeller:
      "판매자에게 결제했는지 확인하세요. 악의적 인 클릭으로 인해 계정이 동결됩니다.",
    payBuyer: "구매자의 지불 정보를 받았는지 확인하십시오",
    account: "계정",
    sellerPay: "구매자가 당신에게 지불했는지 확인하십시오? ",
    payattion:
      "지불 확인 후 가능한 한 빨리 판매자에게 지불하십시오. 악의적 인 클릭은 계정을 직접 동결시킬 것입니다.",
    log: "c2c가 주문을 완료했습니다",
  },
  // 계약
  lever: {
    nowentrust: "현재 신뢰",
    hisentrust: "역사적 위임",
    lvchi: "계약 보유",
    all: "모두",
    or: "또는",
    gotrade: "거래 시작",
    tdrecord: "거래 기록",
    dealed: "거래 됨",
    notdeal: "미처리",
    loading: "로드 중 ...",
    entotal: "총 위탁",
    canuse: "유효한",
    std: "시장 가격 거래",
    xtd: "거래 제한",
    pprice: "가격을 입력하세요",
    phand: "구입 수량을 입력 해주세요",
    phandsell: "판매 된 로트 수를 입력하세요",
    pwd: "암호",
    ppwd: "거래 비밀번호를 입력하세요",
    psw: "트랜잭션 비밀번호",
    equal: "같음",
    times: "타임스",
    timed: "배수",
    hand: "손",
    hands: "손",
    ptimes: "배수를 선택하세요",
    phands: "핸드 수를 선택하세요",
    contractVal: "계약 시장 가치",
    bail: "마진",
    canBail: "사용 가능한 마진",
    charge: "거래 서비스 수수료",
    domore: "매수 (매수)",
    doshort: "매도 (숏)",
    dmore: "더 많이",
    dshort: "짧은",
    sureOd: "주문 확인",
    noless: "핸드 수가 적을 수 없습니다",
    nomore: "핸드의 수는 더 높을 수 없습니다",
    tdnum: "거래량",
    risk: "위험률",
    allloss: "포지션의 총 손익",
    onehouse: "원 클릭 청산",
    type: "유형",
    entrustPrice: "맡기다 가격",
    openPrice: "개장 가격",
    nowPrice: "현재 가격",
    styPrice: "이익 가격",
    stsPrice: "손절매 가격",
    openTime: "개장 시간",
    closeTime: "종료 시간",
    rate: "취급 수수료",
    nightFee: "숙박 요금",
    loss: "이익과 손실",
    setloss: "설정된 이익 및 손절매",
    expectProfit: "기대 이익",
    expectLoss: "예상 손실",
    allClose: "모든 포지션 닫기",
    moreClose: "더 많은 주문 만 마감",
    nullClose: "빈 주문 만 마감",
    sureClose: "포지션 청산을 확인 하시겠습니까? ",
    thanZearo: "설정된 값은 0보다 커야합니다",
    listin: "주문 보류",
    tdin: "거래 중",
    closein: "닫힌 위치",
    closed: "폐쇄 포지션",
    revoked: "취소됨",
    revokeOrder: "주문을 취소 하시겠습니까? ",
    ping: "종가 위치",
    revoke: "주문 취소",
    sureping: "당신은 포지션을 닫으시겠습니까? ",
    thanzone: "설정된 값은 0보다 커야합니다.",
  },
  // 동전
  cuy: {
    direction: "방향",
    total: "합계",
    price: "가격",
    sell: "매도",
    buy: "구매",
    allStation: "올 스테이션 트레이딩",
    buyPrice: "구매 가격",
    buynum: "매수량",
    sellPrice: "판매 가격",
    sellnum: "판매량",
    tdPrice: "거래 금액",
    or: "또는",
    tdStart: "거래 시작",
    pbPrice: "구매 가격을 입력하세요",
    pbNum: "구매 금액을 입력하세요",
    psPrice: "판매 가격을 입력하세요",
    psNum: "판매 금액을 입력하세요",
    fixPrice: "제한 가격 거래",
    Mtrans: "시장 가격 거래",
    available: "사용 가능",
    revoke: "취소",
    loading: "로드 중",
    confirmCancel: "정말로 취소 하시겠습니까? ",
    confirm: "확인",
    cancel: "취소",
    nomore: "더 이상 데이터 없음",
    evelPrice: "평균 거래 가격",
  },
  // 자산
  asset: {
    confirmhuazhuan: "이체를 확인 하시겠습니까?",
    asset: "자산",
    currency_account: "통화 계정",
    lever_account: "계약 계정",
    fince_account: "법정 화폐 계정",
    change_account: "거래 계좌",
    micro_account: "두 번째 계약 계정",
    miscroAccount: "두 번째 계약 계정",
    assets_hua: "자금 이체",
    all_assets: "전환 된 총 자산",
    currency: "통화",
    canuse: "유효한",
    frezz: "고정",
    conversion: "변환 됨",
    charging: "코인 충전",
    withdraw: "인출",
    address_bind: "바인드 인출 주소",
    address_withdraw: "출금 주소 관리",

    record: "기록",
    tbrecord: "출금기록",
    address_charge: "코인 주소",
    address_width: "출금 주소",
    copy: "부",
    ercode: "QR 코드",
    reminder: "따뜻한 알림",
    notcharge: "위 주소로 아무것도 충전하지 마세요",
    ornone: "그렇지 않으면 자산이 복구되지 않습니다",
    support:
      "입금은 간편 송금 방식 만 지원합니다. 다른 방식 (모두 보내기)을 이용한 입금은 일시적으로 게시 할 수 없으므로 양해 부탁드립니다. ",
    minnum: "최소 출금 금액",
    ratenum: "취급 수수료",
    havenum: "도착 수량",
    from: "보낸 사람",
    to: "에",
    transfer: "이전",
    tfnum: "전송 횟수",
    ptfnum: "가장 낮은 값을 입력하십시오",
    dtfnum: "이체 횟수",
    canbalance: "사용 가능한 잔액",
    sureConfirm: "이체 확인",
    moneyRecord: "재무 기록",
    pNum: "이체 횟수를 입력하세요",
    leverUse: "계약 계정을 사용할 수 있습니다",
    legalUse: "법적 통화 계정을 사용할 수 있습니다",
    changeUselg: "코인 계정을 사용할 수 있습니다",
    changeUse: "거래 계좌를 사용할 수 있습니다",
    microUse: "두 번째 계약 계정을 사용할 수 있습니다",
    look: "보기",
    chargeRecord: "코인 충전 기록",
    status: "추적 상태",
    noopen: "이 기능은 아직 열려 있지 않습니다.",
    enterAdderses: "출금 주소를 입력하세요",
    enterNum: "코인 개수를 입력하세요",
    lessMin: "입력 한 출금 횟수가 최소 금액보다 적습니다",
    tips01:
      "위 주소로 다른 자산을 충전하지 마십시오. 그렇지 않으면 자산이 회수되지 않습니다. ",
    tips02:
      "입금은 간편 송금 방식 만 지원하며, 다른 방식 (모두 보내기)을 이용한 입금은 일시적으로 게시 할 수 없으니 양해 바랍니다. ",
    beizhu: "비고",
    pbeizhu: "메모를 입력하세요",
    add: "추가",
    addressList: "주소 목록",
    delete: "삭제",
    norec: "아직 기록 없음",
    selectCurrency: "통화를 선택하세요",
    chainType: "체인 유형",
    commissionLibrary: "커미션 라이브러리",
  },
  // 계정 설정
  set: {
    mycode2: "내 인증 코드",
    copycode2: "인증 코드 복사",
    uaccont: "계정 보안 수준 :",
    strong: "강한",
    middle: "에",
    weak: "약함",
    min: "낮은",
    heigh: "높은",
    complete: "계정 보안을 위해 추가 정보 개선",
    mycode: "내 초대 코드",
    copycode: "초대 코드 복사",
    bindphone: "바인드 폰",
    bindemail: "메일 함 바인딩",
    loginpwd: "로그인 비밀번호",
    noBind: "언 바운드",
    binds: "묶다",
    bind: "바인딩으로 이동",
    binded: "경계",
    net: "인터넷 계정은 도난 당할 위험이 있습니다. 계정 보안을 위해 정기적으로 비밀번호를 변경하는 것이 좋습니다. ",
    reset: "수정",
    setPsw: "거래 보안을 위해 거래 비밀번호를 설정합니다. ",
    goSet: "세트로 이동",
    bindAccount: "바인드 상환 계정",
    duihuan: "계정을 연결하여 포인트 사용",
    copysuccess: "복사 성공",
    copyfail: "복사 실패",
    recopy: "다시 복사하십시오",
    account: "계정",
    detail: "상세",
    val: "양",
    forgetPsw: "비밀번호 찾기",
    code: "인증 코드",
    getCode: "인증 코드 받기",
    setPsw: "비밀번호 설정",
    enterPsw: "암호를 입력하십시오",
    pswFalse: "입력 한 두 암호가 일치하지 않습니다.",
    enterPswagain: "비밀번호를 다시 입력하세요",
    jsetPsw: "트랜잭션 비밀번호 설정",
    jenterPsw: "거래 비밀번호를 입력하세요",
    jenterPswagain: "거래 비밀번호를 다시 입력하세요",
    enterAccount: "계정을 입력하십시오",
    enterCode: "확인 코드를 입력하십시오",
    accountFalse: "입력 한 전화 또는 이메일 계정이 규칙을 충족하지 않습니다!",
    second: "초",
    sendCode: "인증 코드 보내기",
    sendsucc: "전송 성공",
    enterPswTwo: "암호를 두 번 입력하십시오",
    rest: "남은",
    yes: "예",
    no: "아니",
    yorn: "거래 비밀번호 설정 여부",
    authenticate: "인증해주세요",
  },
  // 인증
  auth: {
    identity: "신원 인증",
    name: "이름",
    idcard: "신분증 카드",
    upimg:
      "증명 사진을 올려주세요. 첫 번째는 앞면, 두 번째는 뒷면, 세 번째는 증명 사진 앞면 사진입니다. ",
    submit: "제출",
    auditing: "감사 중 ...",
    certified: "인증!",
    pname: "이름을 입력하세요",
    pidcard: "신분증 번호를 입력하세요",
    pimg: "신분증 사진을 올려주세요!",
  },
  // 결제 방법
  seting: {
    pmethod: "결제 수단",
    truename: "실명",
    opening: "개설 은행 이름",
    bank: "은행 카드 번호",
    alipay: "알리 페이 계정",
    wename: "위챗 별명",
    wechat: "위챗 계정",
    pname: "실명을 입력 해주세요",
    popen: "계좌 은행 명을 입력 해주세요",
    pcard: "은행 카드 번호를 입력하세요",
    palipay: "알리 페이 계정을 입력하세요",
    pwname: "위챗 별명을 입력하십시오",
    pwaccount: "위챗 계정을 입력하세요",
    pimg1: "위챗 소장 코드",
    pimg2: "알리 페이 컬렉션 코드",
  },
  // 지원 센터
  news: {
    seeall: "모두보기",
    helpcenter: "도움말 센터",
    back: "return",
  },
  //로그인
  login: {
    welcome: "로그인을 환영합니다",
    phoneLogin: "모바일 로그인",
    emailLogin: "사서함 로그인",
    account: "계정",
    psw: "암호",
    login: "로그인",
    nouser: "아직 Besencexchange 사용자가 아니십니까? ",
    goRegister:
      "지금 등록하고 세계 최고의 디지털 자산 거래 플랫폼에서 거래를 시작하세요. ",
    registerFree: "무료 등록",
    psw6: "암호는 6 자리 이상이어야합니다.",
  },
  register: {
    register: "등록",
    phoneRegister: "전화 등록",
    emailRegister: "이메일 등록",
    country: "국적",
    enterPhone: "전화 번호를 입력하세요",
    enterEmail: "이메일을 입력하세요",
    psw16: "암호는 6 ~ 16 자리입니다.",
    inviteCode: "초대 코드",
    sel: "필수",
    sel2: "필요하지 않음",
    read: "나는 읽고 동의했습니다",
    xieyi: ' "사용자 동의"',
    tips01:
      "등록 후 국적 정보는 수정할 수 없으므로 반드시 정직하게 선택 해주세요. ",
    tips02:
      "확인 이메일이 스팸으로 잘못 판단 될 수 있으니주의 깊게 확인하시기 바랍니다. ",
    tips03: "Besencexchange 계정과 로그인 비밀번호를 올바르게 보관하십시오. ",
    tips04: "다른 웹 사이트와 동일한 로그인 비밀번호를 사용하지 마십시오. ",
    emailFalse: "입력하신 이메일 주소가 규칙에 맞지 않습니다.",
  },
  // 사용
  jc: {
    title: "Besencexchange",
    balance: "밸런스",
    cannum: "사용 가능한 JC 번호",
    new: "최신 가격",
    exnum: "교환 수량",
    pnum: "JC 번호를 입력하십시오",
    canex: "아름다운 컨버터블 양",
    exnow: "지금 교환",
    record: "교환 기록",
    exprice: "교환 가격",
    extime: "교환 시간",
    not: "사용 가능한 포인트가 부족합니다",
    usenum: "JC 번호 사용",
    out: "종료",
    gotd: "거래로 이동",
  },
  coin: {
    manage: "재무 관리",
    total: "총 예금 코인",
    bao: "보물을 받아라",
    mybao: "내 입금 코인",
    profit: "예상 이익",
    cuntime: "코인 타임",
    endtine: "만기 시간",
  },
  team: {
    myteam: "내 팀",
    ztnum: "직접 푸시 번호",
    activenum: "활성 팀 구성원 수",
    이익: "이익",
    back: "리베이트",
    cblog: "코인 입금 기록",
    bblog: "동전 기록",
  },
  // k 라인
  kline: {
    text1: "시분할",
    text2: "1 분",
    text3: "5 분",
    text4: "15 분 ",
    text5: "30 분 ",
    text6: "1 시간",
    text7: "1 일",
    text8: "1 주",
    text9: "1 월",
  },
  frame: {
    a: "당신은 새로운 인출증 상태가 있으니, 클릭하여 보십시오",
    b: "취소",
    c: "결정하다.",
    con: "친애하는 사용자 여러분, 트레이딩 센터에는 많은 회원이 거래하고 있기 때문입니다. 은행 계좌는 주기적으로 업데이트됩니다. 사용자의 돈의 안전을 위해 트레이딩 센터의 온라인 고객 서비스에 문의하십시오. 모든 송금 전에 최신 은행 계좌 정보를 받으려면 행복한 삶",
  },
  // 두 번째 계약
  miscro: {
    trade: "트레이딩",
    buyPrice: "구매 가격",
    finshPrice: "거래 가격",
    loss: "예상 손익",
    times: "카운트 다운",
    mode: "거래 모드",
    num: "열린 포지션 수",
    rate: "수익률",
    up: "구매",
    down: "구매",
    openNum: "개봉 수량을 입력하세요",
    success: "주문이 성공적으로 완료되었습니다! ",
    c2c: "C2C 계정",
    complaint: "불만 제안",
    reply: "질문을 적어 주시면 최대한 빨리 답변 해 드리겠습니다 ...",
    complaintList: "불만 제안 목록",
    complaintReply: "답장 :",
    ClaimDescription: "설명을 입력하십시오",
    resetpwd: "암호 변경",
    foundOn: "생성 일",
    commonProblem: "일반적인 문제",
    statement: "설명",
    about: "Besencexchange 정보",
    everyone: "모두가 CEO입니다",
    program: "Besencexchange 글로벌 파트너 프로그램",
    program2: "파트너 프로그램",
    myMine: "내 내 :",
    friend: "내 친구 :",
    myRank: "내 순위 :",
    accumulated: "누적 커미션 :",
    copyLinks: "프로모션 링크 복사",
    moneyVein: "사람의 연결이 돈이됩니다",
    example: "커미션 예",
    enterQuantity: "수량을 입력하십시오",
    contractBalance: "계약 계정 잔액",
    submitRepeatedly: "제출 중, 반복해서 제출하지 마십시오",
    alipayCode: "알리 페이 지불 코드",
    wechatCode: "위챗 결제 코드",
    realPrice: "실시간 가격",
    currencyExchange: "교환 통화",
    currencyExchangeIn: "통화로 교환",
    cashableBalance: "현금 잔액 :",
    minimumCashable: "최소 현금화 가능 :",
    maximumCashable: "최대 현금화 가능 :",
    automaticallys: "사용을 클릭하면 자동으로 완료되며 반환 할 수 없습니다.",
    match: "다이얼",
    title: "자산 교환",
    holdAssets: "자산 보유",
    dangerousCurrency: "위험한 통화",
    convertibleQuantity: "변환 가능 수량",
    currencyExchanges: "통화 환율 :",
    InsuranceCurrency: "보험 통화",
    InsuranceType: "보험 유형",
    contractAsset: "계약 자산 보험 금액",
    warehouses: "안전 창고 수량",
    availableAssets: "사용 가능한 자산 :",
    insuredAssets: "보험 자산 :",
    insuredAssets1: "보험 자산",
    InsuranceAssets: "보험 자산 :",
    purchaseInsurance: "보험 구매",
    InsuranceClaims: "보험 청구",
    InsuranceCancellation: "보험 취소",
    coinWallet: "보험 코인 지갑",
    bmbWallet: "우연 지갑",
    cumulativeCoins: "누적 코인 :",
    availableQuantity: "사용 가능한 수량 :",
    rawCurrency: "신용 기록",
    contractInsurance: "계약 보험",
    tenThousand: "10,000",
    runningLow: "잔액 부족",
    purchase: "입력 한 수량이 규정에 맞지 않으며 구매 금액이 있습니다.",
    reach: "에",
    between: "사이",
    onlyEnter: "입력 만 가능",
    integersBetween: "정수 사이",
    notReturned:
      "보험을 구매하려면 클릭하세요. 보험 조약을 자세히 이해하고 보험 창고가 자동으로 적용되며 반환 할 수 없다는 데 동의 한 것으로 간주됩니다.",
    settled:
      "보험에 가입 된 자산이 주문을 할 수 없을 정도로 잃을 경우 보험 청구가 정산됩니다.",
    profitable: "자산이 수익성이있을 때",
    terminated: "보험이 자동으로 종료 될 때.",
    automatically:
      "보험 자산이 50 % 손실되면 보험 청구를 신청해야합니다. 그렇지 않으면 거래 할 수 없습니다. 이익이 100 %이면 보험이 자동으로 종료됩니다. 보험 창고는 하루에 두 번만 지불 할 수 있습니다. 두 번 이상이면 t + 1이 지불합니다.",
    termination:
      "보험 해지 후 보험에 가입 한 자산은 교환 만 할 수 있습니다. 계약 해지 후 불이행으로 간주하고 보험 창고는 자동으로 반제됩니다.",
    just: "긍정적",
    back: "반환",
    lowerNumber: "가장 낮은 숫자는",
    confirmExchange: "교환을 확인 하시겠습니까?",
    contractValuation: "계약 계정 자산 평가",
    secondValuation: "두 번째 계약 계정 자산 평가",
    falshValuation: "패션 계정 자산 평가",
    c2cValuation: "C2C 계정 자산 평가",
    recordWithdrawal: "입금 및 출금 기록",
    category: "카테고리",
    safetyCenter: "안전 센터",
    safeText1: "등록, 비밀번호 변경, 보안 설정시 확인 SMS 수신에 사용",
    safeText2:
      "인터넷 계정이 도용 될 위험이 있습니다. 계정 보안을 위해 정기적으로 비밀번호를 변경하는 것이 좋습니다.",
    flashTrading: "플래시 거래",
    assetCenter: "자산 센터",
    promotionCode: "내 프로모션 코드",
    loginAgain: "로그인이 오래되었습니다. 다시 로그인하십시오.",
    text10: "우연 기반 실시간 가격",
    text11: "인증 코드",
  },
};

// WEBPACK FOOTER //
// ./src/lang/kor.js
